import { gql, useMutation } from '@apollo/client'

const CLOSE_ABUSE_CASE_MUTATION = gql`
  mutation CloseAbuseCase($abuseCaseId: Int!) {
    closeAbuseCase(abuseCaseId: $abuseCaseId)
  }
`

export function useCloseAbuseCase() {
  const [closeCase, { loading }] = useMutation(CLOSE_ABUSE_CASE_MUTATION)

  const handleCloseCase = async ({ abuseCaseId }: { abuseCaseId: number }) => {
    return await closeCase({ variables: { abuseCaseId } })
  }

  return { closeCase: handleCloseCase, loading }
}
